import { Typography, Button, Modal, Flex } from 'antd';
import {
  CalendarOutlined,
  CheckOutlined,
  MailOutlined
} from '@ant-design/icons';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { reserveSupervision } from './utils/reserveSupervision';

const { Text } = Typography;

const StyledTitle = styled.span`
  display: flex;
  align-items: center;
  gap: 12px;

  .modal-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: var(--ds-radius-md);
    font-size: 17px;
    background: var(--ds-pear-tint);
    color: var(--ds-pear-ink);
  }
`;

const StyledNotice = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 14px;
  border-radius: var(--ds-radius-lg);
  background: var(--ds-cambridge-tint);
  color: var(--ds-cambridge-dark);
  font-size: 13px;

  .anticon {
    margin-top: 3px;
  }
`;

export const ConfirmReservationModal = ({
  setIsReservationModalOpen,
  isReservationModalOpen,
  supervisionId,
  dispatchAPI,
  message,
  user,
  navigate,
  anounceId
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      title={
        <StyledTitle>
          <span className="modal-icon">
            <CalendarOutlined />
          </span>
          {t('view-ads.modals.titles.reservation')}
        </StyledTitle>
      }
      open={isReservationModalOpen}
      onOk={() => setIsReservationModalOpen(false)}
      onCancel={() => setIsReservationModalOpen(false)}
      width={520}
      footer={
        <Flex justify="flex-end" gap={8}>
          <Button onClick={() => setIsReservationModalOpen(false)}>
            {t('buttons.cancel')}
          </Button>
          <Button
            type="primary"
            icon={<CheckOutlined />}
            onClick={() =>
              reserveSupervision({
                supervisionId,
                dispatchAPI,
                message,
                user,
                navigate,
                t,
                setIsReservationModalOpen,
                anounceId
              })
            }
          >
            {t('buttons.confirm')}
          </Button>
        </Flex>
      }
    >
      <Flex vertical gap={16} style={{ margin: '8px 0 4px' }}>
        <Text style={{ fontSize: 15 }}>
          {t('view-ads.modals.contents.reservation')}
        </Text>
        <StyledNotice>
          <MailOutlined />
          {t('view-ads.modals.contents.email_message')}
        </StyledNotice>
      </Flex>
    </Modal>
  );
};

ConfirmReservationModal.propTypes = {
  setIsReservationModalOpen: PropTypes.func.isRequired,
  isReservationModalOpen: PropTypes.bool.isRequired,
  supervisionId: PropTypes.string.isRequired,
  dispatchAPI: PropTypes.func.isRequired,
  message: PropTypes.func.isRequired,
  user: PropTypes.shape({}).isRequired,
  navigate: PropTypes.func,
  anounceId: PropTypes.string
};

ConfirmReservationModal.defaultProps = {
  navigate: () => {},
  anounceId: ''
};
